import { Link } from "@/components/link";
import { cn } from "@/lib/utils";

export const CVLink = (props: {
  text: string;
  url: string;
  className?: string;
}) => (
  <Link href={props.url}>
    <span
      className={cn(
        "font-medium cursor-pointer hover:text-primary hover:underline hover:underline-offset-4",
        props.className
      )}
    >
      {props.text}
    </span>
  </Link>
);
